import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import AuthService from 'common/auth.service';
import { getCurrentUserData } from 'utils/helper';

// Temporary Staging Client
const STAGING_BASE_URL = 'https://tpzapi.rhatech.in/api/v2';

const stagingDynamicLink = new ApolloLink((operation, forward) => {
  let moduleName;

  if (operation.operationName?.toLowerCase()?.startsWith('admin')) {
    moduleName = operation.operationName.toLowerCase().split('_')[1];
  } else {
    moduleName = operation.operationName.toLowerCase().split('_')[0];
  }

  const httpLink = new HttpLink({
    uri: `${STAGING_BASE_URL}/${moduleName}/graphql`,
    credentials: 'same-origin',
  });

  return httpLink.request(operation, forward);
});

const stagingAuthLink = setContext((_, { headers }) => {
  const { apiKey } = getCurrentUserData();
  const auth = new AuthService();
  const token = auth.getSessionCookie();

  return {
    headers: {
      ...headers,
      'x-api-key': apiKey,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const stagingClient = new ApolloClient({
  link: ApolloLink.from([stagingAuthLink, stagingDynamicLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'no-cache' },
    query: { fetchPolicy: 'no-cache' },
  },
});
